import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'

export interface IAlertFallDetectionLiveItem {
    id: number;
    protectee: {
        id: number;
        name: string;
    };
    alert: {
        createdAt: string; 
        taskManagerAt: string | null; 
        isMyTask: boolean;
        confirm?: string;
    };
}

export interface IFallDetectionLiveData {
    falls: IAlertFallDetectionLiveItem[];
}

export const apiGetAlertFallDetectionLive = async () => {
    return await apiGet<IFallDetectionLiveData>('/alert/falldetection/live')
}

const useQueryGetAlertFallDetectionLive = (enabled: boolean = true) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.apiGetAlertFallDetectionLive(),
        queryFn: async () => {
            const { data } = await apiGetAlertFallDetectionLive()
            return data
        },
        enabled: enabled,
        refetchInterval: 5000, 
    })
}

export default useQueryGetAlertFallDetectionLive 
